import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

interface ITokenResponse {
  readonly token?: string;
}

@Injectable({
  providedIn: 'root',
})
export class WatsonxOrchestrateTokenService {
  constructor(private readonly http: HttpClient) {}

  getIdentityToken$(): Observable<string> {
    const endpoint = environment.watsonxOrchestrate?.tokenEndpoint?.trim();
    if (!endpoint) {
      return throwError(() => new Error('Watsonx token endpoint is missing from environment configuration.'));
    }

    const apiBaseUrl =
      typeof environment.apiUrl === 'string' ? environment.apiUrl : environment.apiUrl.clientApiUrl;

    const url = this.buildUrl(apiBaseUrl, endpoint);

    return this.http.get(url, { responseType: 'text', withCredentials: true }).pipe(map((response) => this.extractToken(response)));
  }

  private buildUrl(apiBaseUrl: string, endpoint: string): string {
    if (/^https?:\/\//i.test(endpoint)) {
      return endpoint;
    }

    const normalizedBase = apiBaseUrl.replace(/\/+$/, '');
    const normalizedPath = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;

    if (normalizedBase.endsWith('/publicapi') && normalizedPath.startsWith('/publicapi/')) {
      return `${normalizedBase}${normalizedPath.replace(/^\/publicapi/, '')}`;
    }

    return `${normalizedBase}${normalizedPath}`;
  }

  private extractToken(response: string): string {
    const raw = (response || '').trim();
    if (!raw) {
      throw new Error('Watsonx token endpoint returned an empty response.');
    }

    if (!raw.startsWith('{')) {
      return raw;
    }

    try {
      const parsed = JSON.parse(raw) as ITokenResponse;
      const token = parsed?.token?.trim();
      if (token) {
        return token;
      }
    } catch {
      // Non-JSON responses are allowed to support plain text token endpoints.
    }

    throw new Error('Watsonx token endpoint response does not contain a usable token.');
  }
}
